<template>
  <div class="mc-sidebar-liveview__fleet">
    <div v-if="!$store.state.fleets.loadingKendaraan">
      <div class="mc-sidebar-liveview__filter">
        <b-row v-if="!search.licensePlate">
          <b-col md="12">
            <button
              :class="
                fleetFilterStatus.all
                  ? 'mc-sidebar-liveview__filter-btn mc-sidebar-liveview__filter-btn--primary'
                  : 'mc-sidebar-liveview__filter-btn'
                "
              @click="showAll()"
            >
              {{ $t('liveView.filter.all') }}
            </button>
            <button
              :class="
                fleetFilterStatus.running
                  ? 'mc-sidebar-liveview__filter-btn mc-sidebar-liveview__filter-btn--success'
                  : 'mc-sidebar-liveview__filter-btn'
              "
              @click="event => updateFilterStatus(event, 'running')"
            >
              {{ $t('liveView.filter.moving') }}
            </button>
            <button
              :class="
                fleetFilterStatus.idle
                  ? 'mc-sidebar-liveview__filter-btn mc-sidebar-liveview__filter-btn--warning'
                  : 'mc-sidebar-liveview__filter-btn'
              "
              @click="event => updateFilterStatus(event, 'idle')"
            >
              {{ $t('liveView.filter.idle') }}
            </button>
            <button
              :class="
                fleetFilterStatus.parking
                  ? 'mc-sidebar-liveview__filter-btn mc-sidebar-liveview__filter-btn--danger'
                  : 'mc-sidebar-liveview__filter-btn'
              "
              @click="event => updateFilterStatus(event, 'parking')"
            >
              {{ $t('liveView.filter.parking') }}
            </button>
            <button
              :class="
                fleetFilterStatus.offline
                  ? 'mc-sidebar-liveview__filter-btn mc-sidebar-liveview__filter-btn--dark'
                  : 'mc-sidebar-liveview__filter-btn'
              "
              @click="event => updateFilterStatus(event, 'offline')"
            >
              {{ $t('liveView.filter.offline') }}
            </button>
          </b-col>
        </b-row>
      </div>

      <b-row class="mc-sidebar-liveview__search-wrapper">
        <b-col md="8">
          <div class="mc-sidebar-liveview__filter-show my-2">
            {{ $t('global.show') }}
            <strong>{{ status.moving + status.idle + status.parking + status.offline }}</strong>
            {{ $t('global.text.vehicleData') }}
            <span v-if="status.moving">
              <strong>{{ status.moving }}</strong> {{ $t('global.filter.running') }}
            </span>
            <span v-if="status.idle">
              <strong>{{ status.idle }}</strong> {{ $t('global.filter.idle') }}
            </span>
            <span v-if="status.parking">
              <strong>{{ status.parking }}</strong> {{ $t('global.filter.parking') }}
            </span>
            <span v-if="status.offline">
              <strong>{{ status.offline }}</strong> {{ $t('global.filter.offline') }}
            </span>
          </div>
        </b-col>

        <b-col md="4" class="my-2">
          <a
            href="#"
            class="btn btn-outline-primary ms-2"
            :class="showHideDetail ? 'mc-collapse' : 'mc-expand'"
            @click="showHideDetail = !showHideDetail"
          >
            <i class="mc-fa icon-fill_expand"></i>
            <i class="mc-fa icon-outline_collapse"></i>
          </a>
          <a
            id="sortFleetBtn"
            href="#"
            class="btn btn-outline-primary mx-2"
            @click="sortPopover = !sortPopover"
          >
            <i class="mc-fa icon-fill_height"></i>
          </a>
          <b-popover
            ref="popover"
            target="sortFleetBtn"
            triggers="click"
            placement="leftbottom"
            :show.sync="sortPopover"
          >
            <b-list-group>
              <b-list-group-item
                :active="orderActive == 2 ? true : false"
                @click="sortBy('licensePlate', 'asc', 'notdate', 2)"
              >
                {{ $t('global.object.licensePlate') }}: ASC
              </b-list-group-item>
              <b-list-group-item
                :active="orderActive == 3 ? true : false"
                @click="sortBy('licensePlate', 'desc', 'notdate', 3)"
              >
                {{ $t('global.object.licensePlate') }}: DESC
              </b-list-group-item>
              <b-list-group-item
                :active="orderActive == 4 ? true : false"
                @click="sortBy('calculatedMotionStatus', 'asc', 'notdate', 4)"
              >
                {{ $t('global.object.fleetStatus') }}: ASC
              </b-list-group-item>
              <b-list-group-item
                :active="orderActive == 5 ? true : false"
                @click="sortBy('calculatedMotionStatus', 'desc', 'notdate', 5)"
              >
                {{ $t('global.object.fleetStatus') }}: DESC
              </b-list-group-item>
            </b-list-group>
          </b-popover>
          <a
            v-b-tooltip.click.topcenter
            class="popup-form btn mc-disabled"
            title="Sedang tahap pengembangan."
          >
            <i class="mc-fa icon-outline_filter" />
          </a>
        </b-col>
      </b-row>
    </div>

    <div v-if="$store.state.fleets.loadingKendaraan" class="text-center">
      <div class="mc-loading">
        <p></p>
        <p></p>
        <p></p>
      </div>
    </div>

    <b-list-group v-else class="mc-sidebar-liveview__list-fleet">
      <b-list-group-item v-for="(row, index) in dataByStatus" :key="index">
        <div class="clearfix">
          <span class="pull-left" @click="Centering(row)">{{ row.licensePlate }}</span>
          <b-badge
            v-if="row.calculatedMotionStatus === 'M'"
            class="bg-success"
            :title="$t('liveView.filter.moving')"
            >{{ $t('liveView.filter.moving') }}</b-badge
          >
          <b-badge
            v-else-if="row.calculatedMotionStatus === 'I'"
            class="bg-warning"
            :title="$t('liveView.filter.idle')"
            >{{ $t('liveView.filter.idle') }}</b-badge
          >
          <b-badge
            v-else-if="row.calculatedMotionStatus === 'P'"
            class="bg-danger"
            :title="$t('liveView.filter.parking')"
            >{{ $t('liveView.filter.parking') }}</b-badge
          >
          <b-badge
            v-else-if="row.calculatedMotionStatus === 'O'"
            class="bg-secondary"
            :title="$t('liveView.filter.offline')"
            >{{ $t('liveView.filter.offline') }}</b-badge
          >
          <b-badge
            v-else-if="row.calculatedMotionStatus === 'U'"
            class="bg-secondary"
            :title="$t('liveView.filter.offline')"
            >{{ $t('liveView.filter.offline') }}</b-badge
          >
        </div>
        <div v-if="showHideDetail" class="mc-sidebar-liveview__list-fleet-showhide">
          <div class="mc-sidebar-liveview__list-fleet-showhide-wrapper">
            <span v-if="row.calculatedMotionStatus === 'M'">
              <i class="mc-fa icon-outline_odometer" /> {{ row.speed }} Km/{{
                $t('global.time.hours')
              }}
            </span>
            <span
              v-else-if="
                row.calculatedMotionStatus === 'P' ||
                row.calculatedMotionStatus === 'I' ||
                row.calculatedMotionStatus === 'O' ||
                row.calculatedMotionStatus === 'U'
              "
            >
              <i class="mc-fa icon-outline_timer" />
              {{ minuteToTime(row.timeInStatus) }}
            </span>
            <span v-if="row.fuelFiltered">
              <i class="mc-fa icon-outline_fuel" /> {{ row.fuelFiltered }} L</span
            >
          </div>
          <div class="mc-sidebar-liveview__list-fleet-showhide-wrapper">
            <span>
              <i class="mc-fa icon-outline_bus" />
              {{ row.vehicle.vehicleType ? row.vehicle.vehicleType.category : 'Tidak Ada Kategori' }}
            </span>
            <span v-if="$store.state.map.pickedColumns.includes('driverName')">
              <i class="mc-fa icon-outline_person" /> {{ row.vehicle.driver1 ? row.vehicle.driver1.fullname : 'Tidak Ada Pengemudi' }}
            </span>
          </div>
        </div>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { Helper } from '@/mixin/helper'
import { mapGetters } from 'vuex'
import responsive from '@/mixin/responsive'

export default {
  name: 'ListFleet',
  mixins: [Helper, responsive],
  data() {
    return {
      search: {
        licensePlate: null,
      },
      orderBy: {
        objName: 'licensePlate',
        order: 'asc',
        type: 'string',
      },
      orderActive: 2,
      fleetFilterStatus: {
        all: true,
        running: false,
        idle: false,
        parking: false,
        offline: false,
      },
      status: {
        moving: 0,
        idle: 0,
        offline: 0,
        parking: 0,
      },
      dataByStatus: [],
      sortPopover: false,
      showHideDetail: false,
    }
  },
  computed: {
    ...mapGetters('fleets', ['fleetsListFilter']),
  },
  created() {
    this.dataByStatus = this.fleetsListFilter(this.search.licensePlate)
    setTimeout(() => {
      this.$store.commit('fleets/ORDER_BY', this.orderBy)
      this.dataByStatus = this.fleetsListFilter(this.search.licensePlate)

      this.totalFleet()
    }, 5000)

    this.$nextTick(function () {
      window.setInterval(() => {
        if (this.$store.state.fleets.autoReload) {
          if (!this.fleetFilterStatus.all) {
            this.filterByStatus()
          } else {
            this.dataByStatus = this.fleetsListFilter(this.search.licensePlate)
          }
        }
      }, 5000)
    })
  },

  mounted() {
    var self = this
    this.$root.$on('refreshFleets', function () {
      self.refreshFleets()
    })

    this.$root.$on('searchFleet', function (payload) {
      self.searchFleet(payload)
    })
  },

  methods: {
    refreshFleets() {
      if (!this.fleetFilterStatus.all) {
        this.filterByStatus()
      } else {
        this.dataByStatus = this.fleetsListFilter(this.search.licensePlate)
      }
    },

    searchFleet(text) {
      this.search.licensePlate = text
      this.dataByStatus = this.fleetsListFilter(this.search.licensePlate)
    },

    showAll() {
      let obj = { ...this.fleetFilterStatus }
      Object.keys(obj).forEach(function (key) {
        if (key !== 'all') {
          obj[key] = false
        } else {
          obj[key] = true
        }
      })
      this.fleetFilterStatus = obj
      this.dataByStatus = this.fleetsListFilter(this.search.licensePlate)
      this.totalFleet()
    },

    totalFleet() {
      this.status.moving = this.fleetsListFilter(this.search.licensePlate).filter(
        (fleet) => fleet.calculatedMotionStatus === 'M'
      ).length

      this.status.idle = this.fleetsListFilter(this.search.licensePlate).filter(
        (fleet) => fleet.calculatedMotionStatus === 'I'
      ).length

      this.status.offline = this.fleetsListFilter(this.search.licensePlate).filter(
        (fleet) => fleet.calculatedMotionStatus === 'O' || fleet.calculatedMotionStatus === 'U'
      ).length

      this.status.parking = this.fleetsListFilter(this.search.licensePlate).filter(
        (fleet) => fleet.calculatedMotionStatus === 'P'
      ).length
    },

    updateFilterStatus(event, param) {
      event.target.blur()

      this.fleetFilterStatus[param] = !this.fleetFilterStatus[param]
      this.fleetFilterStatus.all = false
      let obj = { ...this.fleetFilterStatus }
      let objArr = []
      Object.keys(obj).forEach(function (key) {
        if (obj[key]) {
          objArr.push(true)
        }
      })

      this.filterByStatus()
      if (objArr.length === 4 || objArr.length === 0) {
        this.fleetFilterStatus.all = true
        this.showAll()
      }
    },

    setModal(row) {
      this.$store.dispatch('fleets/setHistory', {
        hullNo: row.vehicle.hullNo,
        type: row.vehicle.vehicleType.type,
        category: row.vehicle.vehicleType.category,
        licensePlate: row.licensePlate,
        imei: row.vehicle.imei,
        vehicleId: row.vehicleId,
        driver: row.driver,
        direction: row.direction,
        calculatedMotionStatus: row.calculatedMotionStatus,
        tripDrivetime: row.tripDrivetime,
        tripDistance: row.tripDistance,
        tripstartOn: row.tripstartOn,
        lastPacket: row.lastPacket,
        latitude: row.latitude,
        longitude: row.longitude,
        lastPositionStatus: row.lastPositionStatus,
      })
      this.$store.dispatch('map/modalFleetHistory', true)
      // this.Centering(row);
    },

    async Centering(gmp) {
      if (this.mediaQuery.matches) {
        this.$store.commit('sidebar/toggleSideBar')
      }

      const data = {
        zoom: 15,
        open: true,
        gmp: gmp,
        type: 'fleet',
      }
      this.$store.dispatch('map/setCENTER', data)
      this.$bvModal.show('modal-info-temp')

      this.$store.dispatch('map/requestAddress', {
        lat: gmp['latitude'],
        lng: gmp['longitude'],
      })
    },

    filterByStatus() {
      var data = []

      this.status.moving = 0
      if (this.fleetFilterStatus.running) {
        var running = this.fleetsListFilter(this.search.licensePlate).filter(
          (fleet) => fleet.calculatedMotionStatus === 'M'
        )
        data.push(...running)
        this.status.moving = running.length
      }

      this.status.idle = 0
      if (this.fleetFilterStatus.idle) {
        var idle = this.fleetsListFilter(this.search.licensePlate).filter(
          (fleet) => fleet.calculatedMotionStatus === 'I'
        )
        data.push(...idle)
        this.status.idle = idle.length
      }

      this.status.parking = 0
      if (this.fleetFilterStatus.parking) {
        var parking = this.fleetsListFilter(this.search.licensePlate).filter(
          (fleet) => fleet.calculatedMotionStatus === 'P'
        )

        data.push(...parking)
        this.status.parking = parking.length
      }

      this.status.offline = 0
      if (this.fleetFilterStatus.offline) {
        var offline = this.fleetsListFilter(this.search.licensePlate).filter(
          (fleet) => fleet.calculatedMotionStatus === 'O' || fleet.calculatedMotionStatus === 'U'
        )
        data.push(...offline)
        this.status.offline = offline.length
      }

      setTimeout(() => {
        this.dataByStatus = data
      }, 200)
    },

    sortBy(objName, order, type, active) {
      this.orderBy = {
        objName: objName,
        order: order,
        type: type,
      }

      this.$store.commit('fleets/ORDER_BY', this.orderBy)

      this.dataByStatus = this.fleetsListFilter(this.search.licensePlate)

      this.orderActive = active
      this.sortPopover = !this.sortPopover
    },
  },
}
</script>
